<template>
  <div class="apply-invoice-wrap">
    <div class="apply-invoice-title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">我的位置</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/user/index' }">我的资产</el-breadcrumb-item>
        <el-breadcrumb-item>申请开票</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="apply-content">
      <div class="title">申请开票</div>
      <div class="tip">
        电子发票与纸质发票具有同等法律效力，可支持报销入账；同时根据增值税管理办法要求，如需为企业开具增值税发票，需提供纳税人识别号或统一社会信用代码，否则该发票无法作为税收凭证。
      </div>
      <div class="form-wrap my-form">
        <el-form autoComplete="on" :model="invoice" v-loading="loading" :rules="invoiceRules"
          element-loading-text="给我一点时间" label-position="right" ref="invoice" label-width="150px" label-suffix="：">

          <el-form-item label="发票类型" prop="type">
            <el-radio-group v-model="invoice.type" text-color="#00b4e8">
              <el-radio :label="0">个人</el-radio>
              <el-radio :label="1">企业</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发票抬头" prop="name">
            <el-input type="text" style="width:350px" v-model="invoice.name" placeholder="请输入发票抬头"> </el-input>
          </el-form-item>
          <el-form-item label="纳税人识别号" prop="name">
            <el-input type="text" style="width:350px" v-model="invoice.name" placeholder="请输入纳税人识别号"> </el-input>
          </el-form-item>
          <el-form-item label="发票内容" prop="detail">
            <el-input style="width:450px" type="textarea" :autosize="{ minRows: 3, maxRows: 6 }" v-model="invoice.detail">
            </el-input>
          </el-form-item>

          <div class="btn-list">
            <el-button class="submit flex-cc" :loading="loading">保存</el-button>
            <el-button class="cancel flex-cc" @click="goBack">取消</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndex } from "@/api/index";
export default {
  name: 'UserInvoice',
  components: {

  },
  data() {
    return {
      loading: true,
      user: {},
      invoice: {
        type: 0,
        name: '',
        tax_no: '',
        detail: '',
      },
      invoiceRules: {
        type: [
          { required: true, message: '请选择发票类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
      },
    };
  },
  computed: {

  },
  created() {
    this.getIndex();
  },
  methods: {

    getIndex() {
      getIndex({}).then(res => {

        this.loading = false;
        this.user = res.data;
      }).catch((err) => {

      });
    },
    goBack() {
      this.$router.go(-1); // 返回上一页
    }
  }
};
</script>

<style lang="scss" scoped>
.apply-invoice-wrap {
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
  border-radius: 2px;
  margin-top: 16px;

  .apply-invoice-title {
    width: 100%;
    padding: 19px 25px;
    border-bottom: 1px solid #CCD7DB;
  }

  .apply-content {
    width: 100%;
    padding: 20px 27px 40px 27px;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      font-weight: 400;
      color: #222222;
    }

    .tip {
      background: #E9F3F6;
      width: 100%;
      padding: 19px 14px 23px 14px;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 400;
      color: #A0A9AC;
      line-height: 28px;
      margin-top: 17px;
    }

    .form-wrap {
      padding-top: 40px;
      width: 50%;
      margin: 0 auto;

      .form-item {
        grid-template-columns: 1fr 4fr;
      }

      .btn-list {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .submit {
          width: 150px;
          height: 40px;
          background: #00B4E8;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 300;
          color: #FFFFFF;
          cursor: pointer;
        }

        .cancel {
          width: 150px;
          height: 40px;
          border-radius: 20px;
          border: 1px solid #00B4E8;
          font-size: 14px;
          font-weight: 300;
          color: #00B4E8;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
